import React from 'react';
import styled from 'styled-components';
import architecture from '../../assets/project/combined.png';
import MaetelProject from './maetelProject';
import InspiremeProject from './inspiremeProject';
import FutureplayProject from './futureplayProject';
import CashwalkProject from './cashwalkProject';
import GatdaProject from './gatdaProject';
import ToyProject from './toyProject';
import ProjectOutline from './projectOutline';

const outlines = [
  {
    tag: '아키텍처',
    heading: ['AWS Cloud'],
    description:
      'Cloud 기반으로 인프라를 구성해 관리, 유지 및 보수에 용이 하도록 설계하고 개발합니다. 코드는 Github 을 활용해 관리하며, Docker 기반의 서버 운용, 그리고 EC2, ECS, S3, CloudFront, RDS 등 AWS 의 서비스를 중심으로 지속운영관리 되도록 개발합니다. Secure, CI/CD 까지 고려합니다.',
    background: 'linear-gradient(45deg, #d38312 30%, #a83279 100%)',
  },
  {
    tag: '데이터베이스',
    heading: ['SQL 또는 NoSQL'],
    description:
      '복잡한 비즈니스 로직을 처리해야 한다면 MySQL 과 PostgreSQL 을 주로 활용하고 있습니다. 필요하다면 AWS 의 DynamoDB 나 MongoDB, 그리고 Redis 등 각 영역에서 서비스에 적당한 데이터베이스 선택해 비용, 속도, 관리에 용이하도록 만들어갑니다. 확장 가능한 스키마 설계와 적절한 ORM 활용을 필수죠.',
    background: 'linear-gradient(45deg, #44a08d 30%, #093637 100%)',
  },
  {
    tag: 'APIs',
    heading: ['Client-server model', '그리고 도큐먼트'],
    description:
      '웹 표준 HTTP 통신을 활용한 APIs 를 설계하고, 유저 동작에 따라서 데이터를 조작할 수 있고, 화면에 필요한 정보를 시기 적절하게 내려주거나 요청에 따라 서비스 로직이 동작하도록 인터페이스를 만듭니다. 어디서든 동작 가능하도록, 그리고 필요할 때 사용할 수 있도록 API 정보를 문서화 합니다.',
    background: 'linear-gradient(45deg, #0f1020 30%, #232526 100%)',
  },
  {
    tag: '유저 화면',
    heading: ['고객 중심의 UI/UX', 'Frontend'],
    description:
      '선행 작업된 디자인 또는 레퍼런스가 충분하다면 UI 를 그리는 작업, 그리고 고객의 동작에 따라 고민하면서 UX 를 위한 화면을 개발합니다. 웹이나 모바일 등 필요하다면 어떤 환경에서든 동작하도록 작업합니다. 서비스가 매력적으로 보이도록 화면을 그리는 것도 신경써야 합니다.',
    background: 'linear-gradient(45deg, #1e3c72 30%, #2948ff 100%)',
  },
];

const ProjectBox = ({ lang }) => {
  return (
    <Container>
      <div className='project-intro'>
        <div className='project-heading'>프로젝트</div>
        <div className='project-sub-heading'>
          무에서 유를.
          <br />
          불가능을 <span>가능하도록.</span>
        </div>
        <p className='project-description'>
          신규 서비스를 런칭하고, 운영중인 서비스를 확장하고, 여러 직무의
          작업자들과 소통하면서 효율적인 구조를 설계하고 데이터베이스, APIs,
          서버 및 화면을 개발하고 배포했습니다. A 부터 Z 까지, 필요에 따라
          책임감을 가지고 참여했습니다.
        </p>
        <div className='project-img-box'>
          <div className='project-img' />
        </div>
      </div>
      <div className='project-grid'>
        {outlines.map(({ tag, heading, description, background }) => (
          <ProjectOutline
            key={tag}
            tag={tag}
            heading={heading}
            description={description}
            background={background}
          />
        ))}
        <MaetelProject />
        <InspiremeProject />
        <FutureplayProject />
        <ToyProject />
        <CashwalkProject />
        <GatdaProject />
      </div>
    </Container>
  );
};

const Container = styled.div`
  .project-intro {
    font-size: 48px;
    text-align: left;
    max-width: 380px;
    margin: 0 auto;

    .project-heading {
      font-weight: 700;
    }

    .project-sub-heading {
      color: #fff;
      font-weight: 700;

      span {
        display: block;
      }
    }

    .project-description {
      font-size: 18px;
    }

    .project-img-box {
      display: flex;
      justify-content: center;

      .project-img {
        width: 100%;
        height: 270px;
        background-image: url('${architecture}');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
      }
    }
  }

  .project-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, auto));
    grid-template-rows: repeat(7, minmax(0, auto));
    row-gap: 24px;
    column-gap: 24px;
    margin: 48px 0 24px;
  }

  @media only screen and (min-width: 769px) {
    .project-intro {
      font-size: 64px;
      max-width: 560px;

      .project-heading {
      }

      .project-sub-heading {
        span {
          display: inline;
        }
      }

      .project-description {
        font-size: 24px;
      }

      .project-img-box {
        .project-img {
          min-width: 480px;
          height: 360px;
          background-size: contain;
        }
      }
    }
  }

  @media only screen and (min-width: 1025px) {
    .project-intro {
      max-width: 768px;

      .project-img-box {
        .project-img {
          min-width: 640px;
          height: 480px;
        }
      }
    }
  }
`;

export default ProjectBox;
